import './CalendarHeaderSwitch.scss';
import { useTranslation } from 'react-i18next';
import { Switch, Theme } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { matSwitchStyle } from '../../../assets/style/material/matSyles';


const CalendarHeaderSwitch = ({actual, onHandleChange}) => {
    const { t } = useTranslation();
    const AntSwitch = withStyles((theme: Theme) => matSwitchStyle)(Switch);

    return (
        <div className="c-calendar-header-switch">
            <p className="switch__label-actual">{t('myBlockMonth.stripCalendarHeader.actualCalendar')}</p>
            <AntSwitch 
                checked={actual} 
                name={'plannedToActual'} 
                onChange={onHandleChange} 
            />
            <p className="switch__label-planned">{t('myBlockMonth.stripCalendarHeader.planned')}</p>
        </div>
    )
}

export default CalendarHeaderSwitch;